import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { OfferOrderService } from '../services';
import { IOffer } from '../interfaces';
import { OFFERS_LIST_KEY } from '../constants';

const useOfferUpdateVisible = (offer: IOffer) => {
  const { t } = useTranslation('offerOrder');
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    isPending: isLoading,
    data,
  } = useMutation((visible: boolean) => OfferOrderService.generalInfo({ ...offer, visible }), {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [OFFERS_LIST_KEY] });
      offer?._id && queryClient.invalidateQueries({ queryKey: [offer._id] });
      toast.success(t('provider:visibilitySuccessUpdate'));
    },
    onError: () => {
      toast.error(t('generalErrorMessage', { ns: 'errors' }));
    },
  });

  return {
    updateVisible: mutateAsync,
    isLoading,
    value: data?.data?.visible,
  };
};

export default useOfferUpdateVisible;
